export enum LtiRequestType {
  RESOURCE_LINK = 'LtiResourceLinkRequest',
  DEEP_LINKING = 'LtiDeepLinkingRequest',
}
